<template>
  <crud-modal
    title="Slug anpassen"
    action="update"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-6">
      Soll der Slug von Immobilienfirma
      <span class="font-semibold">"{{ companyName }}"</span> wirklich
      angepasst werden? <br>
      Sämtliche Materialien und Landingpages der Firma müssen neu generiert werden.
    </div>
    <form action="#">
      <label class="block mb-6 normal-case">
        <input-text-validated
          v-model="newSlug"
          label="Neuer Slug"
          type="text"
          rules="required"
          input-class="w-full"
          class="w-full"
        /></label>
    </form>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import UPDATE_COMPANY_SLUG from '@/graphql/UpdateCompanySlug.gql'
import InputTextValidated from '@/components/form/text-validated'

export default {
  components: { CrudModal, InputTextValidated },
  props: {
    companyId: {
      type: String,
      required: true
    },
    companyName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      newSlug: ''
    }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: UPDATE_COMPANY_SLUG,
        variables: {
          input: {
            companyId: this.companyId,
            newSlug: this.newSlug
          }
        }
      })
      this.$router.go(0)
    }
  }
}
</script>
